export default __webpack_public_path__ + "media/images/cross-b529109f9e749db4bb0b8e57ef345a89.svg";